import { Image, Popover, Spin, Tooltip } from "antd"
import { useState, useMemo, useEffect } from "react"
import styles from './index.module.scss'
import { LoadingOutlined, StarOutlined, StarFilled } from '@ant-design/icons';
import Utils from '@utils/utils'
import * as _ from "underscore";
import LazyLoad from '@view/compoents/LazyLoad';
import Iconfont from '@utils/Iconfont';
import { BATCH_IMAGES_TYPE } from "@utils/CONST"
const fallback = require('@assets/images/fallback.png')
// 背景item
const ImageItem = (props) => {
    const { selectList = [], maxCount = 10 } = props
    const [record, setRecord] = useState(props.record)
    const [open, setOpen] = useState(false)

    useEffect(() => {
        setRecord(props.record)
    }, [props.record])
    const bodyRequired = useMemo(() => {
        return props.toolGroup?.onBodyRequired
    }, [props.toolGroup])
    // 可查看大图
    const viewable = useMemo(() => {
        return props.toolGroup?.onPreview
    }, [props.toolGroup])
    // 可收藏
    const favorable = useMemo(() => {
        return props.toolGroup?.onFavor
    }, [props.toolGroup])
    // 可删除
    const removable = useMemo(() => {
        return props.toolGroup?.onRemove
    }, [props.toolGroup])
    // 素材处理中
    const isProgress = useMemo(() => {
        return props.isVideo ?
            record.attr?.status == "processing" :
            ("maskStatus" in record.attr ? record.attr?.maskStatus == "processing" : false)
    }, [record])
    const isFailed = useMemo(() => {
        return props.isVideo ?
            record.attr?.status == "failed" :
            record.attr?.maskStatus == "failed"
    }, [record])
    const isSuccess = useMemo(() => {
        return props.isVideo ?
            record.attr?.status == "succeeded" :
            ("maskStatus" in record.attr ? record.attr?.maskStatus == "succeeded" : true)
    }, [record])
    // 显示自定义icon
    const showCustomIcon = useMemo(() => {
        const isCustom = !!record.attr?.custom
        return isCustom && !props.hideCustomIcon
    }, [record, props.hideCustomIcon])
    // 显示专属素材icon
    const showPrivateIcon = useMemo(() => {
        return !!record.attr?.private
    }, [record])
    // 显示CONST_ID icon
    const showConstIDIcon = useMemo(() => {
        return record.attr?.algoModelType == "constant_id"
    }, [record])
    // 显示标记位置icon
    const showBodyRequiredIcon = useMemo(() => {
        return bodyRequired && !!record.attr?.noBody
    }, [record, bodyRequired])
    const noBodyCoords = useMemo(() => {
        return !record.attr?.coordDrag
    }, [record])
    const bodyCoordsForegroundImage = useMemo(() => {
        return record.attr?.coordDrag?.foregroundImage
    }, [record])

    const subList = useMemo(() => {
        return record.subList?.length > 0 ? record.subList : null
    }, [record])
    const selected = useMemo(() => {
        if (!subList) return selectList.find(item => item.key == record.name)
        else return !!subList.find(item => selectList.find(item2 => item2.key == item.name))
    }, [record, selectList, subList])

    const overflow = useMemo(() => {
        return maxCount <= selectList.length && !selected && maxCount !== 1
    }, [maxCount, selectList, selected])

    const selectable = useMemo(() => {
        if (!isSuccess || subList) return false
        else if (overflow && !selected) return false
        else return true
    }, [isSuccess, subList, overflow, selected])

    const handleOpenChange = (open) => {
        console.log('subList', subList)
        if (!subList) return
        setOpen(open)
    }
    const handleClick = () => {
        props.onClick?.(record)
    }

    const PopoverContent = (
        <div className={`${styles.PopoverContent} _beauty_scrollbar`}>
            {
                record.subList?.filter(item => !/_random/.test(item.name)).map(item => (
                    <div key={item.name} className={`${styles.ImageSubItem} ${selectList.find(item2 => item2.key == item.name) && styles.selected}`} onClick={() => props.onClick(item)}>
                        <Image src={Utils.getImgThumbnail(item.imageUrl, item.attr?.version)} fallback={fallback} preview={false} />
                        {
                            item.attr?.title &&
                            <Tooltip title={item.attr?.title}>
                                <span className={styles.ImageItemTitle}>{item.attr?.title}</span>
                            </Tooltip>
                        }
                        {/* {selectList.find(item2 => item2.key == item.name) && <span className={styles.CheckedIcon}><CheckOutlined /></span>} */}
                    </div>
                ))
            }
        </div>
    )

    const [visible, setVisible] = useState(false)
    const handlePreview = (e) => {
        e.stopPropagation()
        if (props.toolGroup?.onPreview instanceof Function) {
            props.toolGroup?.onPreview()
        } else {
            setVisible(record?.imageUrl)
        }
    }
    const handleRemove = (e) => {
        e.stopPropagation()
        props.toolGroup?.onRemove?.()
    }
    const handleFavor = e => {
        e.stopPropagation()
        props.toolGroup?.onFavor?.()
    }
    const handleBodyRequired = (e) => {
        e.stopPropagation()
        props.toolGroup?.onBodyRequired?.()
    }



    return (
        <>
            <Popover content={PopoverContent} trigger="click" open={open} onOpenChange={handleOpenChange}>
                <div
                    className={`${styles.ImageItem} ${selected && styles.selected}`}
                    onClick={selectable ? handleClick : null}
                    style={{ minWidth: props.minWidth || "none" }}
                >
                    <div className={`${styles.ImageItemContent} ${overflow && styles.overflow}`}>
                        {
                            props.isVideo ?
                                <LazyLoad.Video key={record?.imageUrl} src={Utils.addParamsToUrl(record?.imageUrl, { v: record?.attr?.version })} /> :
                                <LazyLoad.Image key={record?.imageUrl} src={Utils.getImgThumbnail(record?.imageUrl, record?.attr?.version)} />
                        }
                    </div>
                    {
                        bodyRequired &&
                        bodyCoordsForegroundImage &&
                        <div className={styles.ForegroundImage}><LazyLoad.Image key={bodyCoordsForegroundImage} src={Utils.getImgThumbnail(bodyCoordsForegroundImage)} /></div>
                    }
                    {
                        (record?.attr?.title && props.projectType != BATCH_IMAGES_TYPE.TRYON_BATCH) &&
                        <Tooltip title={record?.attr?.title} placement="bottom">
                            <span className={styles.ImageItemTitle}>{record?.attr?.title}</span>
                        </Tooltip>
                    }
                    {showCustomIcon && <span className={styles.ImageItemCustom}>自定义</span>}
                    {showPrivateIcon && <span className={styles.ImageItemPrivate}></span>}
                    {showConstIDIcon && <span className={styles.ImageItemModelType}>CONST_ID</span>}
                    {/* {
                        selected &&
                        <span className={styles.CheckedIcon}><CheckOutlined /></span>
                    }  */}
                    {
                        isProgress ?
                            <div className={styles.SpinWrap}><Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} /></div> :
                            <div className={styles.TriggerWrap}>
                                {(favorable && record?.isFavorite) ? <div className={`${styles.TriggerItem} ${styles.favorited}`} onClick={handleFavor}><StarFilled style={{ color: "#FFA600" }} /></div> : null}
                                {(favorable && !record?.isFavorite) ? <div className={styles.TriggerItem} onClick={handleFavor}><StarOutlined /></div> : null}
                                {(removable && record.attr?.custom) && <div className={styles.TriggerItem} onClick={handleRemove}><Iconfont type="icon-DeleteOutlined" /></div>}
                                {viewable && <div className={styles.TriggerItem} onClick={handlePreview}><Iconfont type="icon-FullscreenOutlined" /></div>}
                                {showBodyRequiredIcon && <div className={`${styles.TriggerTag} ${noBodyCoords && styles.noBodyCoords}`} onClick={handleBodyRequired}>标记位置</div>}
                            </div>
                    }
                    {
                        record?.subList?.length > 0 && <div className={styles.subIconWrap}><Iconfont className={styles.subIcon} type="icon-copyOutlined" /></div>
                    }
                </div>
            </Popover>
            <div style={{ display: "none" }}>
                <Image
                    preview={{
                        visible,
                        src: visible,
                        destroyOnHidden: true,
                        onVisibleChange: value => {
                            setVisible(value);
                        },
                    }}
                />
            </div>
        </>
    )
}

export default ImageItem